
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MCPConfig } from "@shared/index";
import { ConfirmationService, MenuItem } from 'primeng/api';
import { Button, ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DrawerModule } from 'primeng/drawer';
import { Popover } from "primeng/popover";
import { TableModule } from "primeng/table";
import { BulkAction, BulkActionBarComponent } from 'src/app/shared/components/bulk-action-bar/bulk-action-bar.component';
import { TagModule } from 'primeng/tag';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TooltipModule } from 'primeng/tooltip';
import { McpService } from '@shared-angular/services/mcp.service';
import { RouteShareService } from "src/app/shared/services/route-share.service";
import { ManualLinkComponent } from "../../../../../../shared/components/rag-admin/manual-link/manual-link.component";
import { McpAddEditExternalComponent } from "./mcp-add-edit-external/mcp-add-edit-external.component";
import { McpAddEditManagedComponent } from "./mcp-add-edit-managed/mcp-add-edit-managed.component";

@Component({
  selector: 'app-mcp-server-tab',
  imports: [
    DrawerModule,
    McpAddEditManagedComponent,
    McpAddEditExternalComponent,
    TableModule,
    BulkActionBarComponent,
    Popover,
    ButtonModule,
    FormsModule,
    TagModule,
    ConfirmDialogModule,
    TooltipModule,
    TieredMenuModule,
    ManualLinkComponent
],
  providers: [ConfirmationService],
  templateUrl: './mcp-server-tab.component.html',
  styleUrl: './mcp-server-tab.component.scss'
})
export class McpServerTabComponent {
  public get bulkActions(): BulkAction[] {
    return [
      {
        id: 'bulk-remove',
        label: $localize`:@@bulk-remove:Entfernen`,
        icon: 'ri ri-delete-bin-line',
        command: () => this.removeSelectedMcps()
      }
    ];
  }

  public mcpService = inject(McpService);
  private activePop: Popover | null = null;
  public contextMenu: (MenuItem & { command: () => void })[] = [];
  public openedCreator?: string;
  public openedEditor?: MCPConfig;
  public selectedMcps: MCPConfig[] = [];

  public get allSelected(): boolean {
    return this.mcpService.mcps.length > 0 && this.selectedMcps.length === this.mcpService.mcps.length;
  }

  public rss = inject(RouteShareService);

  constructor(
    private confirmationService: ConfirmationService
  ) { }

  public getToolListForMCP(mcp: MCPConfig): MenuItem[] {
    const tools = mcp.type === "managed" ? mcp.allowed_tools : mcp.tool.allowed_tools;
    return tools.map((toolName: string) => {
      return {
        label: toolName,
        disabled: false,
        command: () => {
          console.log({ toolName });
        }
      };
    });
  }

  public openMenu(event: MouseEvent, popover: Popover, mcp: MCPConfig, button: Button) {
    if (this.activePop && this.activePop !== popover) {
      this.activePop.hide();
    }
    this.contextMenu = this.getMenuItems(mcp);
    popover.toggle(event, button.el.nativeElement);
    this.activePop = popover;
  }

  private getMenuItems(mcp: MCPConfig) {
    const menu: (MenuItem & { command: () => void })[] = [];
    menu.push({
      label: $localize`:@edit:Bearbeiten`,
      icon: `ri-pencil-fill`,
      command: () => {
        this.openedEditor = mcp;
      }
    });
    menu.push({
      label: $localize`:@@remove:Entfernen`,
      icon: 'ri ri-delete-bin-line',
      command: () => {
        this.confirmationCheck(mcp._id);
      }
    });
    return menu;
  }

  public toggleAll(checked: boolean): void {
    this.selectedMcps = checked ? [...this.mcpService.mcps] : [];
  }

  public removeSelectedMcps(): void {
    this.confirmationService.confirm({
      header: $localize`:@@confirm-remove-mcps:Ausgewählte MCP-Server entfernen`,
      icon: 'ri-error-warning-line',
      message: $localize`:@@confirm-remove-message-mcps:Möchtest du die ausgewählten MCP-Server entfernen? Der Bot kann sie danach nicht mehr nutzen.`,
      rejectButtonProps: {
        label: $localize`:@@delete-reject:Abbrechen`,
        severity: 'secondary',
        outlined: true
      },
      acceptButtonProps: {
        label: $localize`:@@remove-accept:Entfernen`,
        severity: 'danger'
      },
      accept: async () => {
        const mcps = [...this.selectedMcps];
        for (const mcp of mcps) {
          await this.mcpService.deleteMcp(this.rss.botConfig._id, mcp._id);
        }
        this.selectedMcps = [];
      }
    });
  }

  public confirmationCheck(mcpId: string) {
    this.confirmationService.confirm({
      header: $localize`:@@confirm-remove-mcp:MCP-Server entfernen`,
      icon: 'ri-error-warning-line',
      message: $localize`:@@confirm-remove-message-mcp:Möchtest du diesen MCP-Server entfernen? Der Bot kann ihn danach nicht mehr nutzen.`,
      rejectButtonProps: {
        label: $localize`:@@delete-reject:Abbrechen`,
        severity: 'secondary',
        outlined: true
      },
      acceptButtonProps: {
        label: $localize`:@@remove-accept:Entfernen`,
        severity: 'danger'
      },
      accept: async () => {
        await this.mcpService.deleteMcp(this.rss.botConfig._id, mcpId);
        this.selectedMcps = this.selectedMcps.filter(mcp => mcp._id !== mcpId);
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
}
